module.exports = __webpack_public_path__ + "static/img/img-no3.7a8afc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daping/img-no3.png
// module id = ogBt
// module chunks = 0